export const TEST_ID_PRICE_COMPARER = 'price-comparer';
